var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Iconfont',{staticClass:"avatorImg",attrs:{"size":22,"name":_vm.vehicleIconName()}})
}
var staticRenderFns = []

export { render, staticRenderFns }